import React, { forwardRef, ReactNode } from 'react';

import { GeneralInfoSectionRow } from '../GeneralInfoSectionRow';
import styles from './ResizableWrapper.css';

export const ResizableWrapper = forwardRef<HTMLDivElement, { children: ReactNode }>(({ children }, ref) => {
  return (
    <GeneralInfoSectionRow ref={ref} className={styles['wrapper']}>
      {children}
    </GeneralInfoSectionRow>
  );
});

ResizableWrapper.displayName = 'ResizableWrapper';
